<template>
  <!--container-->
  <v-dialog v-model="showModalOne" max-width="250px" max-height="250px">
    <v-card>
      <v-icon
        color="green lighten-2"
        class="text-right"
        v-on:click="closeModal()"
      >
        mdi-close-circle
      </v-icon>

      <v-form ref="form" v-model="valid">
        <h2 class="textHead pt-1">Accounting Promotion</h2>

        <br />

        <v-img
          :src="
            require('@/assets/closeup-economist-using-calculator-while-going-through-bills-taxes-office.jpg')
          "
          height="200"
        />
        <br />
        <p class="mt-1 text pb-5">
          <a href="https://kenwynaccounting.com/accounting-promotion-2023"
            >Click Here</a
          >
          to check our latest Promotion
        </p></v-form
      >
    </v-card>
  </v-dialog>
  <!--container-->
</template>

<script>
export default {
  name: "Downloadguide",

  data() {
    return {
      showModalOne: false,
    };
  },
  mounted() {
    setTimeout(() => {
      if (!localStorage.getItem("showModalOne")) {
        this.showModalOne = true;
      }
    }, 500);
  },
  methods: {
    closeModal() {
      this.showModalOne = false;
      localStorage.setItem("showModalOne", true);

      console.log("Showed model");

      if (localStorage.getItem("showModalOne") == false) {
        console.log("Showed Not model");
        setTimeout(() => {
          this.showModalOne = false;
        }, 5000);
      }
    },
  },
};
</script>
<style scoped>
.text {
  text-align: center;
}
.textHead {
  text-align: center;
}
.button {
  font-size: 12px;
}
a {
  text-decoration: none;
}
</style>


